import { executeRequest, Request } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { getRequestFromEntityFormData } from './eosCreateWorkItem'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}

export const getDedupe: any = (onboardingData: any, metaData: any, originalMerchant, tokens: any) => {
  const requestBody: any = getRequestFromEntityFormData(onboardingData, metaData, undefined)
  if (originalMerchant) {
    requestBody.originalMerchant = getRequestFromEntityFormData(originalMerchant, metaData, {}).merchant
  }
  console.log('htag requestBody', requestBody)
  const request: Request<{}> = {
    apiPath: getUrl(APIEndPoints.getDedupe),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: requestBody,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}
